import axios from 'axios'
import { HTTPResponseModel } from '../../../common/models/HTTPResponseModel'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}Authentication/GetUserByToken`
export const LOGIN_URL = `${API_URL}Authentication/AuthenticateUser`
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`
export const GET_FRESH_TOKEN_URL = `${API_URL}Authentication/RefreshToken?`
export const INIT_PASSWORD_URL = `${API_URL}Authentication/SendInitPasswordLink?Email=`
export const CHECK_INIT_PASSWORD_KEY = `${API_URL}Authentication/CheckInitPasswordKey?Key=`
export const SAVE_NEW_PASSWORD = `${API_URL}Authentication/SaveNewPassword?Key=`
export const GET_ACTIVE_EMAIL_BY_CODE = `${API_URL}Authentication/ActivateNewEmailByCode`

// Server should return AuthModel
export function login(Login: string, Password: string) {
  return axios.get<HTTPResponseModel>(LOGIN_URL + '?' + new URLSearchParams({
    Login,
    Password,
  }))
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken(token: string) {
  return axios.get<HTTPResponseModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    headers: {
      AccessToken: token
    }
  })
}

export function getInitPasswordLink(email: string) {
  return axios.get<HTTPResponseModel>(INIT_PASSWORD_URL + email)
}

export const getCheckInitpwdKey = (Key: string) => {
  return axios.get<HTTPResponseModel>(CHECK_INIT_PASSWORD_KEY + Key)
}

export const refreshToken = (RefreshToken: string) => {
  return axios.get<HTTPResponseModel>(GET_FRESH_TOKEN_URL + new URLSearchParams({RefreshToken}))
}

export const saveNewPassword = ({Key, Password}: {Key: string, Password: string}) => {
  return axios.get<HTTPResponseModel>(SAVE_NEW_PASSWORD + Key + '&Password=' + Password)
}


export const getChangeEmailCode = (Code:string) => {
  const headers = { 'Content-Type': 'application/json' }
  return fetch(`${GET_ACTIVE_EMAIL_BY_CODE}?Code=${Code}`, { headers,method: "GET"})
      .then((d) => d.json())
}